module.exports = __webpack_public_path__ + "ni.e1dfe9bd73a46209f258.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/ni.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/ni.svg
// module chunks = styles